import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useDynamicContext, useIsLoggedIn } from "@dynamic-labs/sdk-react-core";
import isEmpty from "lodash.isempty";

import { UrlParams } from "@/constants";
import { ProfileScreens } from "@/pages/profile/components/Menu";
import { authActions } from "@/store";
import useAuth from "./useAuth";

export const useDripitTicketQR = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isLoggedIn = useIsLoggedIn();
  const { isAuthenticated, isInitialized } = useAuth();
  const { setShowAuthFlow } = useDynamicContext();

  React.useEffect(() => {
    const isClaimTicketPath = window.location.pathname === "/claimTicket";
    const params = new URLSearchParams(window.location.search);
    const ticketQR =
      params.get(UrlParams.TICKET_QR) ??
      localStorage.getItem(UrlParams.TICKET_QR);
    const ticketsTabPath = `/profile?${UrlParams.PROFILE_TAB}=${ProfileScreens.Tickets}&${UrlParams.TICKET_QR}=${ticketQR}`;

    if (!isEmpty(ticketQR) && !isLoggedIn && isClaimTicketPath) {
      localStorage.setItem(UrlParams.TICKET_QR, ticketQR as string);
      navigate(`/${!isEmpty(params) ? "" : "?" + params.toString()}`, {
        replace: true,
      });
      setShowAuthFlow(true);
      dispatch(authActions.toggleTriggerLogin());
    } else if (
      !isEmpty(ticketQR) &&
      isInitialized &&
      isAuthenticated &&
      isLoggedIn
    ) {
      navigate(ticketsTabPath, {
        replace: false,
      });
      localStorage.removeItem(UrlParams.TICKET_QR);
    }
  }, [isLoggedIn, isAuthenticated, isInitialized]);
};
